import React, { Component } from "react";
import { service, actions } from "./log-data";
import { injectIntl, IntlShape } from "@ai360/core/intl";
import { withCrud } from "~/hocs";
import { DataTable } from "~/core";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";
import { messages } from "../i18n-messages";

interface ICropLogProps {
    records?: Record<string, unknown>[];
    intl: IntlShape;
}

export class CropLog_ extends Component<ICropLogProps> {
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render(): JSX.Element {
        return (
            <DataTable
                service={service}
                isCheckbox={false}
                showFilterInput={false}
                messages={messages}
                {...this.props}
                records={this.getFormattedRecords(this.props.records)}
            />
        );
    }
}
export const CropLog = injectIntl(withCrud(CropLog_, service, actions));
